import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="bg-primary">
      <div className="container-custom py-4">
        <nav className="flex items-center justify-between">
          <Link to="/" className="text-white text-2xl font-bold">
            PCAB Reporting System
          </Link>
          <div className="flex gap-4 items-center">
            <Link to="/" className="text-white hover:text-gray-200">Home</Link>
            <Link to="/report" className="text-white hover:text-gray-200">Submit Report</Link>

            {isAuthenticated() ? (
              <>
                <Link to="/dashboard" className="text-white hover:text-gray-200">Dashboard</Link>
                <span className="text-white text-sm">
                  Welcome, {user?.email || 'User'}
                </span>
                <button
                  onClick={handleLogout}
                  className="text-white hover:text-gray-200 bg-transparent border border-white px-3 py-1 rounded"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" className="text-white hover:text-gray-200">Login</Link>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
